module.exports = __webpack_public_path__ + "assets/DeliveryFeeGift-424c79.svg";